"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeListUsersState = exports.changePasswordUserState = exports.changeUpdateUserState = exports.changeCreateUserState = exports.clearAllUserForms = exports.clearPasswordUserParams = exports.clearUpdateUserParams = exports.clearCreateUserParams = exports.changePasswordUserParams = exports.changeUpdateUserParams = exports.changeCreateUserParams = exports.changeUserListConfig = exports.CHANGE_USER_LIST_CONFIG = exports.loadUserIdToChangePassword = exports.LOAD_USER_ID_TO_CHANGE_PASSWORD = exports.loadUserToView = exports.LOAD_USER_TO_VIEW = exports.loadUserToUpdate = exports.LOAD_USER_TO_UPDATE = exports.changeUserState = exports.CHANGE_USER_STATE = exports.clearUserParams = exports.CLEAR_USER_PARAMS = exports.changeUserParams = exports.CHANGE_USER_PARAMS = exports.setUsers = exports.SET_USERS = void 0;

var _reduxBatchedActions = require("redux-batched-actions");

var _createAction = require("skybase-ui/skybase-core/base/create-action");

var _getActionName = require("skybase-ui/skybase-core/utils/get-action-name");

var _constants = require("./constants");

var _constants2 = require("../constants");

var CREATE_USER = _constants.USER_STATE_KEYS.CREATE_USER,
    UPDATE_USER = _constants.USER_STATE_KEYS.UPDATE_USER,
    CHANGE_PASSWORD = _constants.USER_STATE_KEYS.CHANGE_PASSWORD,
    LIST = _constants.USER_STATE_KEYS.LIST;
var SET_USERS = (0, _getActionName.getActionName)('SET_USERS', _constants2.MODULE_NAME);
exports.SET_USERS = SET_USERS;

var setUsers = function setUsers(users) {
  return (0, _createAction.createAction)(SET_USERS, {
    users: users
  });
};

exports.setUsers = setUsers;
var CHANGE_USER_PARAMS = (0, _getActionName.getActionName)('CHANGE_USER_PARAMS', _constants2.MODULE_NAME);
exports.CHANGE_USER_PARAMS = CHANGE_USER_PARAMS;

var changeUserParams = function changeUserParams(key, attribute, value) {
  return (0, _createAction.createAction)(CHANGE_USER_PARAMS, {
    key: key,
    attribute: attribute,
    value: value
  });
};

exports.changeUserParams = changeUserParams;
var CLEAR_USER_PARAMS = (0, _getActionName.getActionName)('CLEAR_USER_PARAMS', _constants2.MODULE_NAME);
exports.CLEAR_USER_PARAMS = CLEAR_USER_PARAMS;

var clearUserParams = function clearUserParams(key) {
  return (0, _createAction.createAction)(CLEAR_USER_PARAMS, {
    key: key
  });
};

exports.clearUserParams = clearUserParams;
var CHANGE_USER_STATE = (0, _getActionName.getActionName)('CHANGE_USER_STATE', _constants2.MODULE_NAME);
exports.CHANGE_USER_STATE = CHANGE_USER_STATE;

var changeUserState = function changeUserState(key, state) {
  return (0, _createAction.createAction)(CHANGE_USER_STATE, {
    key: key,
    state: state
  });
};

exports.changeUserState = changeUserState;
var LOAD_USER_TO_UPDATE = (0, _getActionName.getActionName)('LOAD_USER_TO_UPDATE', _constants2.MODULE_NAME);
exports.LOAD_USER_TO_UPDATE = LOAD_USER_TO_UPDATE;

var loadUserToUpdate = function loadUserToUpdate(user) {
  return (0, _createAction.createAction)(LOAD_USER_TO_UPDATE, {
    user: user
  });
};

exports.loadUserToUpdate = loadUserToUpdate;
var LOAD_USER_TO_VIEW = (0, _getActionName.getActionName)('LOAD_USER_TO_VIEW', _constants2.MODULE_NAME);
exports.LOAD_USER_TO_VIEW = LOAD_USER_TO_VIEW;

var loadUserToView = function loadUserToView(user) {
  return (0, _createAction.createAction)(LOAD_USER_TO_VIEW, {
    user: user
  });
};

exports.loadUserToView = loadUserToView;
var LOAD_USER_ID_TO_CHANGE_PASSWORD = (0, _getActionName.getActionName)('LOAD_USER_ID_TO_CHANGE_PASSWORD', _constants2.MODULE_NAME);
exports.LOAD_USER_ID_TO_CHANGE_PASSWORD = LOAD_USER_ID_TO_CHANGE_PASSWORD;

var loadUserIdToChangePassword = function loadUserIdToChangePassword(id) {
  return (0, _createAction.createAction)(LOAD_USER_ID_TO_CHANGE_PASSWORD, {
    id: id
  });
};

exports.loadUserIdToChangePassword = loadUserIdToChangePassword;
var CHANGE_USER_LIST_CONFIG = (0, _getActionName.getActionName)('CHANGE_USER_LIST_CONFIG', _constants2.MODULE_NAME);
exports.CHANGE_USER_LIST_CONFIG = CHANGE_USER_LIST_CONFIG;

var changeUserListConfig = function changeUserListConfig(config) {
  return (0, _createAction.createAction)(CHANGE_USER_LIST_CONFIG, {
    config: config
  });
}; // Factory actions


exports.changeUserListConfig = changeUserListConfig;

var changeCreateUserParams = function changeCreateUserParams(attribute, value) {
  return changeUserParams(CREATE_USER, attribute, value);
};

exports.changeCreateUserParams = changeCreateUserParams;

var changeUpdateUserParams = function changeUpdateUserParams(attribute, value) {
  return changeUserParams(UPDATE_USER, attribute, value);
};

exports.changeUpdateUserParams = changeUpdateUserParams;

var changePasswordUserParams = function changePasswordUserParams(attribute, value) {
  return changeUserParams(CHANGE_PASSWORD, attribute, value);
};

exports.changePasswordUserParams = changePasswordUserParams;

var clearCreateUserParams = function clearCreateUserParams() {
  return clearUserParams(CREATE_USER);
};

exports.clearCreateUserParams = clearCreateUserParams;

var clearUpdateUserParams = function clearUpdateUserParams() {
  return clearUserParams(UPDATE_USER);
};

exports.clearUpdateUserParams = clearUpdateUserParams;

var clearPasswordUserParams = function clearPasswordUserParams() {
  return clearUserParams(CHANGE_PASSWORD);
};

exports.clearPasswordUserParams = clearPasswordUserParams;

var clearAllUserForms = function clearAllUserForms() {
  return function (dispatch) {
    dispatch((0, _reduxBatchedActions.batchActions)([clearCreateUserParams(), clearUpdateUserParams(), clearPasswordUserParams()]));
  };
};

exports.clearAllUserForms = clearAllUserForms;

var changeCreateUserState = function changeCreateUserState(state) {
  return changeUserState(CREATE_USER, state);
};

exports.changeCreateUserState = changeCreateUserState;

var changeUpdateUserState = function changeUpdateUserState(state) {
  return changeUserState(UPDATE_USER, state);
};

exports.changeUpdateUserState = changeUpdateUserState;

var changePasswordUserState = function changePasswordUserState(state) {
  return changeUserState(CHANGE_PASSWORD, state);
};

exports.changePasswordUserState = changePasswordUserState;

var changeListUsersState = function changeListUsersState(state) {
  return changeUserState(LIST, state);
};

exports.changeListUsersState = changeListUsersState;
//# sourceMappingURL=actions.js.map